import React from 'react';
import {Link} from 'react-router-dom';
import {ShowIf} from 'components/utils';
import {Businesses, User} from 'api';
import {LoadingPage} from 'components/loading-page';
import {NoContent} from 'components/no-content';
import {NeedOfferItem} from '../need-offer';
import {toastr} from 'react-redux-toastr';

class DemandContent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      isLoading: false,
      count: 0,
      skip: 0,
      limit: 10
    };
    this.loadMore = this.loadMore.bind(this);
  }

  componentDidMount() {
    const params = {
      id: this.props.userId ? this.props.userId : this.props.businessId
    };
    const requestDemand = this.props.userId ? User.actions.countDemand.request(params) : Businesses.actions.countDemand.request(params);
    this.setState({isLoading: true});
    requestDemand.then((response) => {
      this.setState({count: response.data.count, isLoading: false});
      this.getList();
    }).catch((error) => {
      this.setState({isLoading: false});
    });
  }

  getList() {
    const params = {
      id: this.props.userId ? this.props.userId : this.props.businessId,
      filter: {
        limit: this.state.limit,
        skip: this.state.skip,
        order: 'createdAt DESC',
        include: 'categories'
      }
    };
    params.filter = JSON.stringify(params.filter);
    const requestDemand = this.props.userId ? User.actions.demands.request(params) : Businesses.actions.demands.request(params);
    this.setState({isLoading: true});
    requestDemand.then(response => {
      let demands = this.state.data;
      response.data.map((item, idx) => {
        demands.push(item);
      });
      this.setState({data: demands, isLoading: false});
    }).catch(() => {
      this.setState({isLoading: false});
    });
  }

  loadMore() {
    this.setState({skip: this.state.skip + 10}, () => {
      this.getList();
    });
  }

  render() {
    return (
      <div className="post-demand-content">
        <LoadingPage isShow={this.state.isLoading} />
        <ShowIf condition={this.state.data.length > 0}>
          <div>
            {
              this.state.data.map((item, idx) => {
                return (
                  <NeedOfferItem key={idx} {...item}/>
                );
              })
            }
          </div>
        </ShowIf>
        <ShowIf condition={!this.state.isLoading && this.state.data.length == 0}>
          <NoContent content='Không có nhu cầu nào' height={540}/>
        </ShowIf>
        <ShowIf condition={!this.state.isLoading && this.state.data.length > 0 && (this.state.skip + this.state.limit) < this.state.count}>
          <div className="btn-see-more-wrap">
            <button className="btn-see-more" onClick={this.loadMore}>Xem Thêm</button>
          </div>
        </ShowIf>
      </div>
    );
  }
}

export default DemandContent;



// WEBPACK FOOTER //
// ./components/my-business/sub-view/need-offer/DemandContent.jsx